 function initFlickity() {
    const findFlickity = setInterval(function(){
      const sliders = document.querySelectorAll('.fcs-flickity');
      if(sliders.length > 0){
        clearInterval(findFlickity);
        sliders.forEach(slider => {
          if (!slider.classList.contains('flickity-enabled')) {
            new Flickity(slider, {
              cellAlign: 'left',
              contain: true,
              groupCells: true,
              wrapAround: false,
              pageDots: false,
              prevNextButtons: true
            });
          }
        });
      }
    },500);
  }
  initFlickity();
  console.log('hello');